module.exports = __webpack_public_path__ + "static/duth-bf446474ee1df48d9a5dabf2367f86d7.png";